import { useTranslation } from 'react-i18next';
import { ModelReviewSummary } from 'types/Apis/SearchURL';

import BaseAggregateCard from '../Reviews/AggregateCard';

interface AggregateCardProps {
  reviewSummary: ModelReviewSummary;
}

export default function AggregateCard({ reviewSummary }: AggregateCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseAggregateCard
      title={t('seoSrp.ownerReviews.aggregateCard.header')}
      color="red"
      writeReviewHref="https://docs.google.com/forms/d/e/1FAIpQLSeUGpTgb_54f6TLvU8Vj74mlZxd8pBzhGrpsYBcslCHcYzcrw/viewform"
      {...reviewSummary}
      categoryAverages={{
        [t('seoSrp.ownerReviews.overall')]: reviewSummary.overallRating,
        [t('seoSrp.ownerReviews.value')]: reviewSummary.breakdownByCategoryAverages.valueRating,
        [t('seoSrp.ownerReviews.style')]: reviewSummary.breakdownByCategoryAverages.styleRating,
        [t('seoSrp.ownerReviews.performance')]:
          reviewSummary.breakdownByCategoryAverages.performanceRating,
        [t('seoSrp.ownerReviews.comfort')]: reviewSummary.breakdownByCategoryAverages.comfortRating,
        [t('seoSrp.ownerReviews.fuelEconomy')]:
          reviewSummary.breakdownByCategoryAverages.fuelEconomyRating,
        [t('seoSrp.ownerReviews.reliability')]:
          reviewSummary.breakdownByCategoryAverages.maintenanceRating,
      }}
    />
  );
}
